"use strict";
/**
 * Created by rouven on 13.04.17.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var SelectInput_1 = __importDefault(require("./SelectInput"));
var VirtualizedSelectInput_1 = __importDefault(require("./VirtualizedSelectInput"));
var helpers_1 = require("../../helpers");
var Select = function (_a) {
    var options = _a.options, props = __rest(_a, ["options"]);
    var selectOptions = options instanceof Array
        ? options.map(function (option) { return ({
            value: (0, helpers_1.stringifyValue)(option.value),
            label: option.label
        }); })
        : (0, helpers_1.buildOptions)(options);
    var Component = selectOptions.length > 100
        ? VirtualizedSelectInput_1["default"]
        : SelectInput_1["default"];
    return react_1["default"].createElement(Component, __assign({ options: selectOptions }, props));
};
Select.defaultProps = {
    placeholder: 'Bitte auswählen...',
    noResultsText: 'Kein Ergebnis gefunden'
};
Select.propTypes = {
    options: prop_types_1["default"].oneOfType([prop_types_1["default"].array, prop_types_1["default"].object]),
    placeholder: prop_types_1["default"].node,
    noResultsText: prop_types_1["default"].node
};
exports["default"] = Select;
